import { getpersoninfo, loginout } from "@/request/api";

const state = {
  userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
};

const getters = {
  isLogin: (state) => !!state.userInfo.loginname,
  // ✅ 判断会员等级是否符合
  isRegtypeAvailable: (state) => (availableRegtypes) => {
    // 1️⃣ 未登录直接 false
    if (!state.userInfo || !state.userInfo.regtype) return false;

    // 2️⃣ 没传限制，默认允许
    if (!availableRegtypes) return true;

    // 3️⃣ 转数组（兼容 "1,2,3" / [1,2,3]）
    let allowList = [];

    if (typeof availableRegtypes === "string") {
      allowList = availableRegtypes.split(",").map((i) => i.trim());
    } else if (Array.isArray(availableRegtypes)) {
      allowList = availableRegtypes.map((i) => String(i));
    }

    // 4️⃣ 当前用户等级
    const userType = String(state.userInfo.regtype);

    // 5️⃣ 判断是否包含
    return allowList.includes(userType);
  },
};


const mutations = {
  SET_USER_INFO(state, info) {
    state.userInfo = info || {};
    localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
  },
  CLEAR_USER_INFO(state) {
    state.userInfo = {};
    localStorage.removeItem("userInfo");
  },
};

let fetchingUserInfo = false; // 防止重复并发请求

const actions = {
  async fetchUserInfo({ commit }) {
    // 如果正在拉取中，直接返回 Promise
    if (fetchingUserInfo) {
      return new Promise((resolve, reject) => {
        const check = setInterval(() => {
          if (!fetchingUserInfo) {
            clearInterval(check);
            if (this.getters["user/isLogin"]) {
              resolve(this.state.user.userInfo);
            } else {
              reject(new Error("未登录"));
            }
          }
        }, 50);
      });
    }

    fetchingUserInfo = true;

    try {
      const res = await getpersoninfo();
      if (res.resultCode === 0) {
        commit("SET_USER_INFO", res.result.data);
        return res.result.data;
      } else {
        commit("CLEAR_USER_INFO");
        throw new Error("未登录");
      }
    } catch (err) {
      commit("CLEAR_USER_INFO");
      throw err;
    } finally {
      fetchingUserInfo = false;
    }
  },

  async logout({ commit }) {
    try {
      await loginout();
    } catch (e) {}

    commit("CLEAR_USER_INFO");

    localStorage.clear();
    sessionStorage.clear();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js